const footers = [
  'cash_available_for_debt_service',
  'net_profit',
  'total_business_loan_payments',
  'total_income',
  'total_expenses',
  'net_personal_cashflow',
  'annual_personal_debt_payments',
]
const globalFooters = [
  'global_loan_payments',
  'global_cashflow'
]

export {
  footers,
  globalFooters
} 